const PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID;
const ADS_ID = process.env.REACT_APP_GOOGLE_ADS_ID;

export const initTracking = () => {
  if (PIXEL_ID && !window.fbq) {
    /* eslint-disable */
    !(function (f, b, e, v, n, t, s) {
      if (f.fbq) return; n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); };
      if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = '2.0'; n.queue = [];
      t = b.createElement(e); t.async = !0; t.src = v; s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    window.fbq('init', PIXEL_ID);
    window.fbq('track', 'PageView');
    /* eslint-enable */
  }
  if (ADS_ID && !window.gtag) {
    const s = document.createElement('script');
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${ADS_ID}`;
    document.head.appendChild(s);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () { window.dataLayer.push(arguments); };
    window.gtag('js', new Date());
    window.gtag('config', ADS_ID);
  }
};

export const trackEvent = (name, params = {}) => {
  try {
    if (window.fbq) window.fbq('trackCustom', name, params);
    if (window.gtag) window.gtag('event', name, params);
  } catch (e) { /* tracking must never break UX */ }
};

// Standard Meta events — fire only on confirmed actions, never on clicks alone.
export const trackViewContent = (params = {}) => {
  try {
    if (window.fbq) window.fbq('track', 'ViewContent', params);
    if (window.gtag) window.gtag('event', 'view_item', params);
  } catch (e) { /* noop */ }
};

export const trackLead = (params = {}) => {
  try {
    if (window.fbq) window.fbq('track', 'Lead', params);
    if (window.gtag) window.gtag('event', 'generate_lead', params);
  } catch (e) { /* noop */ }
};

export const trackContact = (params = {}) => {
  try {
    if (window.fbq) window.fbq('track', 'Contact', params);
    if (window.gtag) window.gtag('event', 'contact', params);
  } catch (e) { /* noop */ }
};
